var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "android", attrs: { id: "wrap" } }, [
    _c("div", { staticClass: "android_header" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("p", { staticClass: "title_1" }, [_vm._v("KOLON의 앱스토어")]),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("p", { staticClass: "title_2" }, [
        _vm._v("KOLON Apps 앱을 설치해 주세요.")
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          attrs: { href: _vm.installUrl },
          on: {
            click: function($event) {
              return _vm.checkDevice($event)
            }
          }
        },
        [_vm._v("설치")]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "android_cont" },
      [
        _c("div", { staticStyle: { "background-color": "#efefef" } }, [
          _vm._m(2),
          _vm._v(" "),
          _vm.plfTpNm == "android"
            ? _c("p", { staticClass: "android_suggest" }, [
                _vm._m(3),
                _vm._v("크롬\n        "),
                _vm._m(4),
                _vm._v("인터넷 브라우저 앱을 권장합니다.\n      ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.plfTpNm == "android"
            ? _c("p", { staticClass: "android_min_ver" }, [
                _vm._v("\n        ※ OS 최소 지원버전: Android 12"),
                _c("br"),
                _vm._v(
                  "\n        (앱마다 조금의 차이는 있을 수 있습니다.)\n      "
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.plfTpNm == "ios"
            ? _c("p", { staticClass: "android_min_ver" }, [
                _vm._v("\n        ※ OS 최소 지원버전: iOS16.6"),
                _c("br"),
                _vm._v(
                  "\n        (앱마다 조금의 차이는 있을 수 있습니다.)\n      "
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _vm._m(5),
        _vm._v(" "),
        _vm.faqInstallList != null && _vm.faqInstallList.length !== 0
          ? _c("faq-list-view", {
              staticClass: "android_faq",
              attrs: {
                list: _vm.faqInstallList,
                title: "설치가 안돼요",
                accordionId: 1
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.faqUseList != null && _vm.faqUseList.length !== 0
          ? _c("faq-list-view", {
              staticClass: "android_faq",
              staticStyle: { "margin-top": "92px" },
              attrs: {
                list: _vm.faqUseList,
                title: "사용이 안돼요",
                accordionId: 2
              }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", [
      _c("img", {
        attrs: {
          src: require("@/assets/image/install/icon-app-kolonapps@2x.png"),
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", [
      _c("img", {
        attrs: {
          src: require("@/assets/image/install/img-ka-logo@2x.png"),
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", [
      _c("img", {
        staticStyle: { width: "82%" },
        attrs: { src: require("@/assets/image/install/main@2x.gif"), alt: "" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("i", [
      _c("img", {
        attrs: { src: require("@/assets/image/install/chrome.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("i", [
      _c("img", {
        attrs: { src: require("@/assets/image/install/browser.png") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "android_need_help" }, [
      _c("p", [
        _vm._v("\n        모바일 앱 사용에 어려움이 있으신가요?\n      ")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fae5bece", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fae5bece","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = null
// module chunks = 